import { useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Card } from "../components/ui/card";
import { ArrowLeft, ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";
import Footer from "../components/Footer";

export default function Sitemap() {
  const navigate = useNavigate();

  const sections = [
    {
      title: "Main Pages",
      links: [
        { name: "Home", path: "/" },
        { name: "Studio", path: "/studio" },
        { name: "Library", path: "/library" },
        { name: "Login", path: "/login" },
        { name: "Sign Up", path: "/signup" },
      ]
    },
    {
      title: "Information",
      links: [
        { name: "Help Center", path: "/help" },
        { name: "Contact", path: "/contact" },
        { name: "Demo", path: "/demo" },
      ]
    },
    {
      title: "Legal",
      links: [
        { name: "Privacy Policy", path: "/privacy" },
        { name: "Terms of Service", path: "/terms" },
        { name: "Cookie Policy", path: "/cookies" },
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <header className="border-b border-gray-200 bg-white px-6 py-4 shadow-sm">
        <div className="max-w-6xl mx-auto flex items-center gap-6">
          <div className="logo-placeholder"></div>
          <Button variant="ghost" onClick={() => navigate('/')} className="text-gray-600 hover:text-gray-900">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back to Home
          </Button>
        </div>
      </header>

      <div className="flex-1 p-6 bg-gray-50">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-8">
            <h1 className="text-4xl font-bold text-gray-900 mb-2">Sitemap</h1>
            <p className="text-gray-600">Navigate all pages on Podmixr Labs</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {sections.map((section, idx) => (
              <Card key={idx} className="bg-white border-gray-200 shadow-md p-6">
                <h2 className="text-xl font-bold text-gray-900 mb-4">{section.title}</h2>
                <ul className="space-y-3">
                  {section.links.map((link, linkIdx) => (
                    <li key={linkIdx}>
                      <Link
                        to={link.path}
                        className="flex items-center justify-between text-gray-700 hover:text-blue-600 transition-colors group"
                      >
                        <span>{link.name}</span>
                        <ChevronRight className="w-4 h-4 text-gray-400 group-hover:text-blue-600" />
                      </Link>
                    </li>
                  ))}
                </ul>
              </Card>
            ))}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
